import {
	type IApiResponse,
	type IAuthSettings,
	type IDropDownItem,
	type IUseFormData,
	type IWalletInfo,
	validateWalletAddress,
} from 'BreetHelpers';
import * as yup from 'yup';

const receiverAddressTest = yup
	.string()
	.test('is-valid-address', 'Invalid wallet address for selected network', function validateAddress(value, context) {
		if (!value || value.trim() === '') return true;
		const { network } = context.parent as { network: string };
		return validateWalletAddress(value, network || '');
	});

export const WalletAddressFormSchema = yup.object({
	amount: yup
		.string()
		.required('Amount is required')
		.test('not-zero', 'Amount is required', (value) => value !== '0'),
	token: yup.string().required('Token is required'),
	network: yup.string().required('Network is required'),
	receiverAddress: receiverAddressTest.required('Receiver Address is required'),
	walletName: yup.string().required('Wallet Name is required'),
});

export type WalletAddressFormSchemaType = yup.InferType<typeof WalletAddressFormSchema>;

export interface IWalletAddressFormComponentProps {
	tokenOptions: IDropDownItem[];
	walletInfoData?: IApiResponse<IWalletInfo>;
	authSettings?: IAuthSettings;
	formDataContextProps: IUseFormData<typeof WalletAddressFormSchema>;
}

export interface IWalletAddressFormCtaProps {
	formDataContextProps: IUseFormData<typeof WalletAddressFormSchema>;
	resetWalletAddressProps: () => void;
	onScanWalletAddress: () => void;
	onSavedWalletAddress: () => void;
	variant?: 'default' | 'save-address';
}
